var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "prod-offer-old__top" };
var _hoisted_2 = { class: "tabs tabs--sm" };
var _hoisted_3 = { class: "tabs__list" };
var _hoisted_4 = { class: "tabs__item" };
var _hoisted_5 = ["href", "onClick"];
var _hoisted_6 = { class: "tabs__link-label" };
import { StatusClassNames } from "../../../../types/StatusClassNames";
import { computed, inject, onMounted, onUnmounted, ref, watch } from "vue";
import { isFullyVisible } from "../../../../utils";
import { useDragToScroll } from "../../../../components/drag_scroll";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferTypeTabs',
    props: /*@__PURE__*/ _mergeModels({
        baseUrl: { type: String, required: true },
        types: { type: Array, required: true },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup: function (__props) {
        var props = __props;
        var activeType = _useModel(__props, "modelValue");
        var tabs = computed(buildTabs);
        var activeTab = ref();
        var wrap = ref();
        var interacted = inject('interacted');
        var dragToScroll;
        if (activeType.value) {
            activeTab.value = tabs.value.find(function (tab) { return tab.title === activeType.value.name; });
        }
        watch(activeTab, function (value) {
            activeType.value = props.types.find(function (type) { return type.name === value.title; });
            setTimeout(centerActiveTab); // нужно дождаться обновления классов в элементе
        });
        onMounted(function () {
            centerActiveTab(true);
            dragToScroll = useDragToScroll(wrap.value);
        });
        onUnmounted(function () {
            dragToScroll.destroy();
            dragToScroll = undefined;
        });
        function onClick(tab) {
            if (!dragToScroll.isDragging()) {
                activeTab.value = tab;
                interacted.value = true;
            }
        }
        function centerActiveTab(direct) {
            if (direct === void 0) { direct = false; }
            var activeElement = wrap.value.querySelector(".tabs__link.".concat(StatusClassNames.active));
            if (!isFullyVisible(activeElement, wrap.value, false)) {
                if (direct) {
                    var rect = activeElement.getBoundingClientRect();
                    var wrapRect = wrap.value.getBoundingClientRect();
                    wrap.value.scrollLeft += wrapRect.width / 2 - rect.width / 2 + rect.left - wrapRect.left;
                }
                else {
                    activeElement.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }
            }
        }
        function buildTabs() {
            var e_1, _a;
            var _b;
            var tabs = [
                {
                    title: 'Все',
                    url: props.baseUrl,
                    active: !activeType.value,
                    disabled: false,
                }
            ];
            try {
                for (var _c = __values(props.types), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var type = _d.value;
                    tabs.push({
                        title: type.name,
                        url: "".concat(props.baseUrl).concat(type.code, "/"),
                        active: type.name === ((_b = activeType.value) === null || _b === void 0 ? void 0 : _b.name),
                        disabled: type.disabled,
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return tabs;
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "tabs__wrap",
                        ref_key: "wrap",
                        ref: wrap
                    }, [
                        _createElementVNode("ul", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, function (tab) {
                                var _a;
                                return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                    _createElementVNode("a", {
                                        href: tab.url,
                                        class: _normalizeClass(["tabs__link", (_a = {}, _a[_unref(StatusClassNames).active] = tab.active, _a['tabs__link--na'] = tab.disabled, _a)]),
                                        onClick: _withModifiers(function ($event) { return (onClick(tab)); }, ["prevent"])
                                    }, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(tab.title), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_5)
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ], 512 /* NEED_PATCH */)
                ])
            ]));
        };
    }
});
